import React from 'react';

import FinishRegistrationVerification from '@/modules/user/components/VerificationByEmail/FinishRegistrationVerification';

const VerificationPage = () => (
  <FinishRegistrationVerification />
);

export default VerificationPage;
